import { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { hasApiExpander } from '@plone/volto/helpers/Utils/Utils';
import config from '@plone/volto/registry';
import { getNavigation } from '@plone/volto/actions/navigation/navigation';
import { NavigationProvider } from './NavigationContext';
import NavigationInner from './NavigationInner';
import type { NavigationItem } from './types';

type NavigationProps = {
  pathname: string;
  type?: string;
};

type RootState = {
  userSession: {
    token: string | null;
  };
  navigation: {
    items: NavigationItem[];
  };
};

const Navigation = ({ pathname, type }: NavigationProps) => {
  const dispatch = useDispatch();
  const token = useSelector((state: RootState) => state.userSession.token, shallowEqual);
  const items = useSelector((state: RootState) => state.navigation.items, shallowEqual);

  useEffect(() => {
    const { settings } = config;
    if (!hasApiExpander('navigation', getBaseUrl(pathname))) {
      dispatch(getNavigation(getBaseUrl(pathname), settings.navDepth));
    }
  }, [pathname, token, dispatch]);

  return (
    <nav className="navigation" id="navigation" aria-label="Site" tabIndex={-1}>
      <NavigationProvider>
        <NavigationInner items={items} type={type} />
      </NavigationProvider>
    </nav>
  );
};

export default Navigation;